import React from "react";
import { Switch } from "react-router-dom";
import { map, pipe, values } from "ramda";

import AppRoute from "./app-route";
import AuthenticationRoute from "./authentication-route";
import routesConfig from "./routes-config";

const mapRoutes = pipe(
  map(({ path, component, layout, isProtected }) =>
    isProtected ? (
      <AuthenticationRoute
        key={path}
        path={path}
        component={component}
        layout={layout}
      />
    ) : (
      <AppRoute key={path} path={path} component={component} layout={layout} />
    )
  ),
  values
);

const Router = () => <Switch>{mapRoutes(routesConfig)}</Switch>;

export default Router;



// WEBPACK FOOTER //
// ./src/routes/router.js